import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import RouteKey from './key';
import AnnouncementListing from '../pages/announcement/AnnouncementListing';

const { error: errorRoute } = RouteKey.child;
const { allNotices } = RouteKey.announcement.child;
const AnnouncementRoute = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <Redirect to={`${path}/${allNotices.route}`} />
      </Route>
      <Route exact path={`${path}/${allNotices.route}`}>
        <AnnouncementListing />
      </Route>

      <Route path="*" exact>
        <Redirect to={`/${errorRoute}`} />
      </Route>
    </Switch>
  );
};

export default AnnouncementRoute;
